import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {ListSubheader} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {s_char_mr} from "../../_signals/s_char_calc";
import {Item} from "../CharStyled";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";
import {mod_15} from "../../_helper/mod_15";
import {v4} from "uuid";
import updChar from "../../_sig_api/updChar";
import {s_app_mobile} from "../../_signals/s_app";

export default function CharMRNSC() {
    useSignals();
    return <Item>
        <Stack direction={'column'}>
            <label>{s_app_mobile.value ? 'MyR' : "Mystische Rüstung:"}</label>
            <Stack direction={'row'}>
                <FormControl variant="standard"
                                           style={{marginLeft: 4}}
                                           sx={{width: 1 / 2}}>
                    <Select key={v4()}
                            value={s_char_mr.value}
                            onChange={e => updChar([{k:'mr',v: parseInt(e.target.value as string)}])}
                    >
                        <ListSubheader>Basis</ListSubheader>
                        {mod_15.map(r => <MenuItem key={v4()} value={r}>{r}</MenuItem>)}
                    </Select>
                </FormControl>
            </Stack>
        </Stack>
    </Item>
}